import {OpenAPI} from "./psc.ts";
import axios from 'axios';

export interface ErrorDetail {
    code: string
}

export default function setupOpenApi() {

    OpenAPI.BASE = process.env.REACT_APP_API_URL ?? "";
    OpenAPI.CREDENTIALS = 'include'
    OpenAPI.WITH_CREDENTIALS = true

    OpenAPI.HEADERS = () => {
        const token = localStorage.getItem("access_token");
        return new Promise((resolver) => {
            resolver({
                Authorization: `Bearer ${token}`,
            });
        });
    };


    axios.interceptors.response.use(function (response) {
        const updatedToken = response.headers['x-authorization'];

        if (updatedToken) {
            localStorage.setItem('token', updatedToken);
        }

        return response;
    }, function (error) {

        if (error.response.status === 401) {
            localStorage.removeItem('access_token');
            window.location.replace('/');
        }

        if (error.response.status === 403) {
            return Promise.reject({code: 'AccessDenied'});
        }

        return Promise.reject();
    });

}
